import { makeGraphqlQuery } from '../graphql/makeGraphqlQuery';
import * as mutations from '../graphql/mutations';
import { Person } from '../types';

export function aktualisierePerson(person: Person): Promise<Person> {
  return makeGraphqlQuery(mutations.aktualisierePerson, {
    person: JSON.stringify(person)
  });
}

export function aktualisierePersonMitKundennummer(person: Person): Promise<Person> {
  return makeGraphqlQuery(mutations.aktualisierePerson, {
    person: JSON.stringify(person),
    mitKundennummer: true
  });
}
